<div class="icon-m icon-left {{typeClass}}">
    <h3>{{item.name}}</h3>
    <p>{{sexLabel}} - {{speciesLabel}}</p>
</div>
